import React from 'react';

import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import CustomErrorCard from '@components/error/CustomErrorCard';
import useText from '@hooks/use-text';

import getPrettyError from './functions';

interface CouldNotFetchVirtualCardProps {
    error: Error | null;
    tryAgainClick?: () => void;
}

const CouldNotFetchVirtualCard = ({ error, tryAgainClick }: CouldNotFetchVirtualCardProps) => {
    const text = useText();

    return (
        <CustomErrorCard
            isModal
            title={text.messageErrorUps}
            description={getPrettyError(error, text)}
            tryAgainClick={tryAgainClick}
            hideBackToOverviewButton
            icon={<RichIcon type={RichIconTypes.DATAFEIL_1} />}
        />
    );
};

export default CouldNotFetchVirtualCard;
